import gql from "graphql-tag"

const fullMetadataFragment = gql`
  fragment fullMetadata on Metadata {
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
`

export default fullMetadataFragment
